module.exports = __webpack_public_path__ + "fad1b6f3d81a1edf374075fc60b34ea3.jpg";